var React = require('react');

function CloseVector (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 9.41423L14.2929 15.7071L15.7071 14.2929L9.41421 8.00002L15.7071 1.70712L14.2929 0.292908L8 6.5858L1.70711 0.292908L0.292892 1.70712L6.58579 8.00002L0.292894 14.2929L1.70711 15.7071L8 9.41423Z","fill":"#746F95"}));
}

CloseVector.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CloseVector;

CloseVector.default = CloseVector;
